// src/utils/dateUtils.js

export const getTodayIST = () => {
  const now = new Date();

  const istYear = now.toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata",
    year: "numeric",
  });

  const istMonth = now.toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata",
    month: "2-digit",
  });

  const istDay = now.toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata",
    day: "2-digit",
  });

  return `${istYear}-${istMonth}-${istDay}`;
};

// export const getTodayIST = () => {
//  return "2026-07-01"; // 👈 tomorrow date for testing
// };